import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { SettlementDetail, SettlementUpdate } from '../types'

export function useUpdateSettlement() {
  return useSettlementMutation<
    { id: string; body: SettlementUpdate },
    SettlementDetail
  >({
    toastKey: 'settlementUpdated',
    request: async ({ id, body }) =>
      (await apiClient.patch<SettlementDetail>(`${settlementsUrl}/${id}`, body))
        .data
  })
}
